export default __webpack_public_path__ + "static/media/page1.db594ba0.png";